import React from "react";
import "../../styles/home.css";
import { Box, Grid, Typography } from "@mui/material";
import img1 from "../../images//Banner/aboutBanner.png";
import Navbar from "../Navbar";

export default function AboutBanner() {
  return (
    <>
      <Box className="homeBanner">
        <Box pt={4}>
          <Navbar />
          <Box mt={8}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    flexDirection: "column",
                    height: "100%",
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#3665D0",
                      }}
                      className="subHeading2Mid"
                    >
                      Lorem Ipsum
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: "55px",
                        lineHeight: "120%",
                        display: "block",
                        marginTop: "1%",
                      }}
                    >
                      About Us
                    </Typography>
                    <Typography className="homeBanner-span4 text2Mid" pt={1}>
                      Each month, more than 3 million job seekers turn to
                      website in their search for work, making over 140,000
                      applications every single day
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box>
                  <img
                    src={img1}
                    alt="bannerCouple"
                    className="homeBanner-couple_img"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}
